import { render, staticRenderFns } from "./TasksPendingConfig.vue?vue&type=template&id=3d9a8889&scoped=true"
import script from "./TasksPendingConfig.vue?vue&type=script&lang=js"
export * from "./TasksPendingConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9a8889",
  null
  
)

export default component.exports